import {DEVICE_WET_STATUS, exists, deviceStatusWet, statusOutOfRange} from "../../util/util";
import moment from "moment/moment";

class DeviceController {
  
  
  cloneDeep(device) {
    return {...device}
  }
  
  _setWetStatus(device) {
    
    let passed = this._setTimePassedSinceLastLog(device);
    let timePassed = Math.floor(passed / 60);

    if(timePassed < 2) {
      return DEVICE_WET_STATUS.SEMI_DRY;
    }
    else if(timePassed >= 2 && timePassed < 4) {
      return DEVICE_WET_STATUS.WET;
    }
    else if(timePassed >= 4) {
      return DEVICE_WET_STATUS.WET_ALERT;
    }
  }
  
  _getLastLogTime(device) {
    
    let logTime;
    
    if(deviceStatusWet(device) || statusOutOfRange(device)) {
      
      if(device.lastLogTime) {

        // let date = moment(device.lastLogTime).utc().format("DD/MM");
        // let time = moment(device.lastLogTime).utc().format("HH:mm");
  
        let date = moment(device.lastLogTime).format("DD/MM");
        let time = moment(device.lastLogTime).format("HH:mm");
        
        logTime = {date: date, time: time};
      }
    }
    
    return logTime;
  }
  
  _setTimePassedSinceLastLog(device) {
  
    let timePassed = 0;
    if(device.lastLogTime) {
    
      let currentTime = moment();
      let lastLogTime = moment(device.lastLogTime);
    
      timePassed = currentTime.diff(lastLogTime, 'minutes');
    }
    return timePassed;
  }
  
  _getTimePassedSinceLastLog(device) {
    
    let logTimePassed = "";
    
    if(deviceStatusWet(device)) {
      
      let timePassed = this._setTimePassedSinceLastLog(device);
      let hoursPassed = Math.floor(timePassed / 60);
      let minutesPassed = timePassed % 60;
      
      // if single digit add zero in front
      if(exists(hoursPassed) && hoursPassed.toString().length === 1) hoursPassed = '0' + hoursPassed;
      if(exists(minutesPassed) && minutesPassed.toString().length === 1) minutesPassed = '0' + minutesPassed;

      logTimePassed = (timePassed !== 0) ? hoursPassed + ":" + minutesPassed : "";
    }
    return logTimePassed;
  }
  
  _getTimePassedSinceLastLogInHours(device) {
    
    let hoursPassed = 0;
    if(deviceStatusWet(device)) {
      let timePassed = this._setTimePassedSinceLastLog(device);
      hoursPassed = Math.floor(timePassed / 60);
    }
    return hoursPassed;
  }
  
}

export default new DeviceController();


// WEBPACK FOOTER //
// ./src/models/device/deviceController.js